import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <MediaSection />
        <AppSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <RankingSection />
        <IndexSection />
        <FaqSection />
        <FeaturesSection />
        <AboutSection />
        <CarouselSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}